'use strict';

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _require = require('events');

var EventEmitter = _require.EventEmitter;

var rlp = require('rlp-encoding');

var util = require('../util');

var BufferList = require('bl');

var ms = require('ms');

var Buffer = require('safe-buffer').Buffer;

var createDebugLogger = require('debug');

var _require2 = require('../util');

var int2buffer = _require2.int2buffer,
    buffer2int = _require2.buffer2int;

var ECIES = require('./ecies');

var debug = createDebugLogger('devp2p:rlpx:peer');
var BASE_PROTOCOL_VERSION = 4;
var BASE_PROTOCOL_LENGTH = 16;
var PING_INTERVAL = ms('15s');
var PREFIXES = {
  HELLO: 0x00,
  DISCONNECT: 0x01,
  PING: 0x02,
  PONG: 0x03
};

var Peer =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(Peer, _EventEmitter);

  function Peer(options) {
    var _this;

    _classCallCheck(this, Peer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Peer).call(this)); // hello data

    _this._clientId = options.clientId;
    _this._capabilities = options.capabilities;
    _this._port = options.port;
    _this._id = options.id;
    _this._remoteClientIdFilter = options.remoteClientIdFilter; // ECIES session

    _this._remoteId = options.remoteId;
    _this._EIP8 = options.EIP8 !== undefined ? options.EIP8 : true;
    _this._eciesSession = new ECIES(options.privateKey, _this._id, _this._remoteId); // Auth, Ack, Header, Body

    _this._state = 'Auth';
    _this._weHello = null;
    _this._hello = null;
    _this._nextPacketSize = 307; // socket

    _this._socket = options.socket;

    _this._socket.on('error', function (err) {
      return _this.emit('error', err);
    });

    _this._socket.once('close', function () {
      clearInterval(_this._pingIntervalId);
      clearTimeout(_this._pingTimeoutId);
      _this._closed = true;
      if (_this._connected) _this.emit('close', _this._disconnectReason, _this._disconnectWe);
    });

    var bl = new BufferList();

    _this._socket.on('data', function (data) {
      if (_this._closed) return;
      bl.append(data);

      while (bl.length >= _this._nextPacketSize) {
        var bytesCount = _this._nextPacketSize;
        var parseData = bl.slice(0, bytesCount);

        try {
          if (_this._state === 'Auth') {
            if (!_this._eciesSession._gotEIP8Auth) {
              try {
                _this._eciesSession.parseAuthPlain(parseData);
              } catch (err) {
                _this._eciesSession._gotEIP8Auth = true;
                _this._nextPacketSize = util.buffer2int(data.slice(0, 2)) + 2;
                continue;
              }
            } else {
              _this._eciesSession.parseAuthEIP8(parseData);
            }

            _this._state = 'Header';
            _this._nextPacketSize = 32;
            process.nextTick(function () {
              return _this._sendAck();
            });
          } else if (_this._state === 'Ack') {
            if (!_this._eciesSession._gotEIP8Ack) {
              try {
                _this._eciesSession.parseAckPlain(parseData);

                debug("Received ack (old format) from ".concat(_this._socket.remoteAddress, ":").concat(_this._socket.remotePort));
              } catch (err) {
                _this._eciesSession._gotEIP8Ack = true;
                _this._nextPacketSize = util.buffer2int(data.slice(0, 2)) + 2;
                continue;
              }
            } else {
              _this._eciesSession.parseAckEIP8(parseData);

              debug("Received ack (EIP8) from ".concat(_this._socket.remoteAddress, ":").concat(_this._socket.remotePort));
            }

            _this._state = 'Header';
            _this._nextPacketSize = 32;
            process.nextTick(function () {
              return _this._sendHello();
            });
          } else {
            _this._parsePacketContent(parseData);
          }
        } catch (err) {
          _this.emit('error', err);
        }

        bl.consume(bytesCount);
      }
    });

    _this._connected = false;
    _this._closed = false;
    _this._disconnectReason = null;
    _this._disconnectWe = null;
    _this._pingIntervalId = null;
    _this._pingTimeout = options.timeout;
    _this._pingTimeoutId = null; // sub-protocols

    _this._protocols = []; // send AUTH if outgoing connection

    if (_this._remoteId !== null) _this._sendAuth();
    return _this;
  }

  _createClass(Peer, [{
    key: "_parseSocketData",
    value: function _parseSocketData(data) {}
  }, {
    key: "_parsePacketContent",
    value: function _parsePacketContent(data) {
      switch (this._state) {
        case 'Header':
          debug("Received header ".concat(this._socket.remoteAddress, ":").concat(this._socket.remotePort));

          var size = this._eciesSession.parseHeader(data);

          this._state = 'Body';
          this._nextPacketSize = size + 16;
          if (size % 16 > 0) this._nextPacketSize += 16 - size % 16;
          break;

        case 'Body':
          var body = this._eciesSession.parseBody(data);

          debug("Received body ".concat(this._socket.remoteAddress, ":").concat(this._socket.remotePort, " ").concat(body.toString('hex')));
          this._state = 'Header';
          this._nextPacketSize = 32; // RLP hack

          var code = body[0];
          if (code === 0x80) code = 0;

          if (code === 0x81) {
            // TODO: for some reason, mailserver messages start by 0x81
            code = body[1];
            body = body.slice(1);
          }

          if (code !== PREFIXES.HELLO && code !== PREFIXES.DISCONNECT && this._hello === null) {
            return this.disconnect(Peer.DISCONNECT_REASONS.PROTOCOL_ERROR);
          }

          var obj = this._getProtocol(code);

          if (obj === undefined) return this.disconnect(Peer.DISCONNECT_REASONS.PROTOCOL_ERROR);
          var msgCode = code - obj.offset;
          var prefix = this.getMsgPrefix(msgCode);
          debug("Received ".concat(prefix, " (message code: ").concat(code, " - ").concat(obj.offset, " = ").concat(msgCode, ") ").concat(this._socket.remoteAddress, ":").concat(this._socket.remotePort));

          try {
            obj.protocol._handleMessage(msgCode, body.slice(1));
          } catch (err) {
            this.disconnect(Peer.DISCONNECT_REASONS.SUBPROTOCOL_ERROR);
            this.emit('error', err);
          }

          break;
      }
    }
  }, {
    key: "_getProtocol",
    value: function _getProtocol(code) {
      if (code < BASE_PROTOCOL_LENGTH) return {
        protocol: this,
        offset: 0
      };
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this._protocols[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var obj = _step.value;
          if (code >= obj.offset && code < obj.offset + obj.length) return obj;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "_handleMessage",
    value: function _handleMessage(code, msg) {
      var _this2 = this;

      var payload = rlp.decode(msg);

      switch (code) {
        case PREFIXES.HELLO:
        case 0x8f:
          // TODO: P2P message
          this._hello = {
            protocolVersion: buffer2int(payload[0]),
            clientId: payload[1].toString(),
            capabilities: payload[2].map(function (item) {
              return {
                name: item[0].toString(),
                version: buffer2int(item[1])
              };
            }),
            port: buffer2int(payload[3]),
            id: payload[4]
          };

          if (this._remoteId === null) {
            this._remoteId = Buffer.from(this._hello.id);
          } else if (!this._remoteId.equals(this._hello.id)) {
            return this.disconnect(Peer.DISCONNECT_REASONS.INVALID_IDENTITY);
          }

          if (this._remoteClientIdFilter) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = this._remoteClientIdFilter[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var filterStr = _step2.value;

                if (this._hello.clientId.toLowerCase().includes(filterStr.toLowerCase())) {
                  return this.disconnect(Peer.DISCONNECT_REASONS.USELESS_PEER);
                }
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          }

          var shared = {};
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = this._hello.capabilities[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var item = _step3.value;
              var _iteratorNormalCompletion4 = true;
              var _didIteratorError4 = false;
              var _iteratorError4 = undefined;

              try {
                for (var _iterator4 = this._capabilities[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                  var obj = _step4.value;
                  if (obj.name !== item.name || obj.version !== item.version) continue;
                  if (shared[obj.name] && shared[obj.name].version > obj.version) continue;
                  shared[obj.name] = obj;
                }
              } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion4 && _iterator4.return) {
                    _iterator4.return();
                  }
                } finally {
                  if (_didIteratorError4) {
                    throw _iteratorError4;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }

          var offset = BASE_PROTOCOL_LENGTH;
          this._protocols = Object.keys(shared).map(function (key) {
            return shared[key];
          }).sort(function (obj1, obj2) {
            return obj1.name < obj2.name ? -1 : 1;
          }).map(function (obj) {
            var _offset = offset;
            offset += obj.length;
            var SubProtocol = obj.constructor;
            var protocol = new SubProtocol(obj.version, _this2, function (code, data) {
              if (code > obj.length) throw new Error('Code out of range');

              _this2._sendMessage(_offset + code, data);
            });
            return {
              protocol: protocol,
              offset: _offset,
              length: obj.length
            };
          });

          if (this._protocols.length === 0) {
            return this.disconnect(Peer.DISCONNECT_REASONS.USELESS_PEER);
          }

          this._connected = true;
          this._pingIntervalId = setInterval(function () {
            return _this2._sendPing();
          }, PING_INTERVAL);

          if (this._weHello) {
            this.emit('connect');
          }

          break;

        case PREFIXES.DISCONNECT:
          this._closed = true;
          this._disconnectReason = payload[0].length === 0 ? 0 : payload[0][0];
          this._disconnectWe = false;

          this._socket.end();

          break;

        case PREFIXES.PING:
          this._sendPong();

          break;

        case PREFIXES.PONG:
          clearTimeout(this._pingTimeoutId);
          break;
      }
    }
  }, {
    key: "_sendAuth",
    value: function _sendAuth() {
      if (this._closed) return;
      debug("Send auth (EIP8: ".concat(this._EIP8, ") to ").concat(this._socket.remoteAddress, ":").concat(this._socket.remotePort));

      if (this._EIP8) {
        this._socket.write(this._eciesSession.createAuthEIP8());
      } else {
        this._socket.write(this._eciesSession.createAuthNonEIP8());
      }

      this._state = 'Ack';
      this._nextPacketSize = 210;
    }
  }, {
    key: "_sendAck",
    value: function _sendAck() {
      if (this._closed) return;
      debug("Send ack (EIP8: ".concat(this._eciesSession._gotEIP8Auth, ") to ").concat(this._socket.remoteAddress, ":").concat(this._socket.remotePort));

      if (this._eciesSession._gotEIP8Auth) {
        this._socket.write(this._eciesSession.createAckEIP8());
      } else {
        this._socket.write(this._eciesSession.createAckOld());
      }

      this._state = 'Header';
      this._nextPacketSize = 32;

      this._sendHello();
    }
  }, {
    key: "_sendMessage",
    value: function _sendMessage(code, data) {
      if (this._closed) return false;
      var msg = Buffer.concat([rlp.encode(code), data]);

      this._socket.write(this._eciesSession.createHeader(msg.length));

      this._socket.write(this._eciesSession.createBody(msg));

      return true;
    }
  }, {
    key: "_sendHello",
    value: function _sendHello() {
      debug("Send HELLO to ".concat(this._socket.remoteAddress, ":").concat(this._socket.remotePort));
      var payload = [int2buffer(BASE_PROTOCOL_VERSION), this._clientId, this._capabilities.map(function (obj) {
        return [Buffer.from(obj.name), int2buffer(obj.version)];
      }), this._port === null ? Buffer.allocUnsafe(0) : int2buffer(this._port), this._id];

      if (!this._closed) {
        if (this._sendMessage(PREFIXES.HELLO, rlp.encode(payload))) {
          this._weHello = payload;
        }

        if (this._hello) {
          this.emit('connect');
        }
      }
    }
  }, {
    key: "_sendPing",
    value: function _sendPing() {
      var _this3 = this;

      debug("Send PING to ".concat(this._socket.remoteAddress, ":").concat(this._socket.remotePort));
      var data = rlp.encode([]);
      if (!this._sendMessage(PREFIXES.PING, data)) return;
      clearTimeout(this._pingTimeoutId);
      this._pingTimeoutId = setTimeout(function () {
        _this3.disconnect(Peer.DISCONNECT_REASONS.TIMEOUT);
      }, this._pingTimeout);
    }
  }, {
    key: "_sendPong",
    value: function _sendPong() {
      debug("Send PONG to ".concat(this._socket.remoteAddress, ":").concat(this._socket.remotePort));
      var data = rlp.encode([]);

      this._sendMessage(PREFIXES.PONG, data);
    }
  }, {
    key: "_sendDisconnect",
    value: function _sendDisconnect(reason) {
      var _this4 = this;

      debug("Send DISCONNECT to ".concat(this._socket.remoteAddress, ":").concat(this._socket.remotePort, " (reason: ").concat(this.getDisconnectPrefix(reason), ")"));
      var data = rlp.encode(reason);
      if (!this._sendMessage(PREFIXES.DISCONNECT, data)) return;
      this._disconnectReason = reason;
      this._disconnectWe = true;
      this._closed = true;
      setTimeout(function () {
        return _this4._socket.end();
      }, ms('2s'));
    }
  }, {
    key: "getId",
    value: function getId() {
      if (this._remoteId === null) return null;
      return Buffer.from(this._remoteId);
    }
  }, {
    key: "getHelloMessage",
    value: function getHelloMessage() {
      return this._hello;
    }
  }, {
    key: "getProtocols",
    value: function getProtocols() {
      return this._protocols.map(function (obj) {
        return obj.protocol;
      });
    }
  }, {
    key: "getMsgPrefix",
    value: function getMsgPrefix(code) {
      return Object.keys(PREFIXES).find(function (key) {
        return PREFIXES[key] === code;
      });
    }
  }, {
    key: "getDisconnectPrefix",
    value: function getDisconnectPrefix(code) {
      return Object.keys(Peer.DISCONNECT_REASONS).find(function (key) {
        return Peer.DISCONNECT_REASONS[key] === code;
      });
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      var reason = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Peer.DISCONNECT_REASONS.DISCONNECT_REQUESTED;

      this._sendDisconnect(reason);
    }
  }]);

  return Peer;
}(EventEmitter);

Peer.DISCONNECT_REASONS = {
  DISCONNECT_REQUESTED: 0x00,
  NETWORK_ERROR: 0x01,
  PROTOCOL_ERROR: 0x02,
  USELESS_PEER: 0x03,
  TOO_MANY_PEERS: 0x04,
  ALREADY_CONNECTED: 0x05,
  INCOMPATIBLE_VERSION: 0x06,
  INVALID_IDENTITY: 0x07,
  CLIENT_QUITTING: 0x08,
  UNEXPECTED_IDENTITY: 0x09,
  SAME_IDENTITY: 0x0a,
  TIMEOUT: 0x0b,
  SUBPROTOCOL_ERROR: 0x10
};
module.exports = Peer;